import React, { Component, Suspense, lazy } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import * as actions from "../actions";

import "../assets/css/theme.min.css";

import Header from "./Header";
import Footer from "./Footer";
const HomePage = lazy(() => import("./HomePage/HomePage"));
const Tour = lazy(() => import("./TourPage/TourPage"));
const Products = lazy(() => import("./ProductPage/Products"));
const Clubhouse = lazy(() => import("./ClubhousePage/Clubhouse"));
const Claims = lazy(() => import("./ClaimPage/ClaimPage"));
const Document = lazy(() => import("./DocumentsPage/DocumentPage"));
const Contact = lazy(() => import("./ContactPage/ContactPage"));
const Competition = lazy(() => import("./Competitions/Competitions"));
const Venues = lazy(() => import("./VenuesPage/VenuesPage"));
const NotFound = lazy(() => import("./NotFound"));

const history = createBrowserHistory();

class App extends Component {
  componentDidMount() {
    this.props.fetchCsrf();
  }

  render() {
    return (
      <div>
        <Router history={history}>
          <div>
            <Header />
            <Suspense fallback={<div className="loading-spinner" />}>
              <Switch>
                <Route
                  exact
                  path="/"
                  component={(props) => <HomePage {...props} />}
                />
                {/* <Route
                  exact
                  path="/tour"
                  component={props => <Tour {...props} />}
                /> */}
                {/* <Route
                  exact
                  path="/products"
                  component={(props) => <Products {...props} />}
                /> */}
                {/* <Route
                  exact
                  path="/clubhouse"
                  component={(props) => <Clubhouse {...props} />}
                /> */}
                <Route
                  exact
                  path="/claims"
                  component={(props) => <Claims {...props} />}
                />
                <Route
                  exact
                  path="/documents"
                  component={(props) => <Document {...props} />}
                />
                <Route
                  exact
                  path="/contact"
                  component={(props) => <Contact {...props} />}
                />
                <Route
                  exact
                  path="/et-discounts"
                  component={(props) => <Competition {...props} />}
                />
                <Route
                  exact
                  path="/venues"
                  component={(props) => <Venues {...props} />}
                />
                <Route
                  path="/et-properties"
                  render={() => <Redirect to="venues" />}
                />
                <Route
                  path="/et-competitions"
                  render={() => <Redirect to="/et-discounts" />}
                />
                <Route
                  path="/get-quote/cover-types"
                  component={() => {
                    window.location =
                      process.env.REACT_APP_GOLF_URL + "/get-quote/cover-types";
                    return null;
                  }}
                />
                <Route
                  path="/terms-and-conditions"
                  component={() => {
                    window.location =
                      process.env.PUBLIC_URL + "/terms-and-conditions.pdf";
                    return null;
                  }}
                />
                <Route
                  path="/docs/ipid.pdf"
                  component={() => {
                    window.location =
                      process.env.REACT_APP_GOLF_URL + "/docs/ipid.pdf";
                    return null;
                  }}
                />
                <Route
                  path="/privacy-policy"
                  component={() => {
                    window.location =
                      process.env.PUBLIC_URL + "/privacy-policy.pdf";
                    return null;
                  }}
                />
                <Route
                  path="/docs/policywording.pdf"
                  component={() => {
                    window.location =
                      process.env.REACT_APP_GOLF_URL +
                      "/docs/policywording.pdf";
                    return null;
                  }}
                />
                <Route
                  path="*"
                  component={(props) => <NotFound {...props} />}
                />
              </Switch>
            </Suspense>
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default connect(null, actions)(App);
